import { useContext, useEffect } from 'react';
import { getGlassSizes } from 'domain/glass';
import { ConfigurationDataContext, GlassStructureContext } from 'context/configuration';
import { AuthContext } from 'context/auth';
import { AppDataContext } from 'context/appData';

const useGlassSize = configurationJsonData => {
	const {
		setTotalGlassSizes,
		setTotalGlassSizesSum,
		setIsSizesFilled,
		setErrorFields,
		setOversizedGlassFields,
	} = useContext(ConfigurationDataContext);
	const { currentUserAdditionalData } = useContext(AuthContext);
	const { configuratorData } = useContext(AppDataContext);
	const { uiHandlerRef } = useContext(GlassStructureContext);

	useEffect(() => {
		if (!configurationJsonData?.glassTypes?.length) return;
		const {
			totalGlassSizes,
			totalGlassSizesSum,
			isSizesValid,
			emptyOrZeroFields,
			oversizedPositions,
		} = getGlassSizes({
			glassTypes: configurationJsonData.glassTypes,
			showPrice: currentUserAdditionalData?.company?.showPrices || false,
			configuratorData,
			glassDb: uiHandlerRef.current.glassDB,
		});

		setTotalGlassSizes(totalGlassSizes);
		setIsSizesFilled(isSizesValid);
		setTotalGlassSizesSum(totalGlassSizesSum);
		setErrorFields(emptyOrZeroFields);
		setOversizedGlassFields(oversizedPositions);
	}, [
		configurationJsonData,
		currentUserAdditionalData,
		configuratorData,
		setErrorFields,
		setOversizedGlassFields,
		setTotalGlassSizes,
		setTotalGlassSizesSum,
		setIsSizesFilled,
		uiHandlerRef,
	]);
};

export default useGlassSize;
